class HotkeyManager {
    constructor() {
        this.stack = [];
        this.pressed = new Set();
        this.push = this.push.bind(this);
        this.remove = this.remove.bind(this);
        this.trigger = this.trigger.bind(this);
    }

    reset() {
        this.pressed.clear();
    }

    push(item) {
        this.stack.push(item);
    }

    remove(item) {
        this.stack = this.stack.filter(i => i !== item);
    }

    trigger (e) {
        const combo = this.buildCombo(e);
        if (!combo) return;

        for (let i = this.stack.length - 1; i >= 0; i--) {
            const item = this.stack[i];
            const handler = item.handlers?.[combo];

            if (handler) {
                e.preventDefault();
                e.stopPropagation();
                handler(e);
                return;
            }
        }
    }

    keydown(e) {
        const key = this.normalizeKey(e.key);
        if (!key) return;

        this.pressed.add(key);
    }

    keyup(e) {
        const key = this.normalizeKey(e.key);
        if (!key) return;

        // build combo từ pressed BEFORE release
        const combo = this.buildComboFromPressed(e);

        // remove key sau khi build
        this.pressed.delete(key);

        if (!combo) return;

        // LIFO stack
        for (let i = this.stack.length - 1; i >= 0; i--) {
            const item = this.stack[i];
            const handler = item.handlers[combo];

            if (handler) {
                e.preventDefault();
                e.stopPropagation();
                handler(e);
                return;
            }
        }
    }

    syncFromEvent(e) {
        this.pressed.clear();

        if (e.ctrlKey) this.pressed.add('ctrl');
        if (e.altKey) this.pressed.add('alt');
        if (e.shiftKey) this.pressed.add('shift');
        if (e.metaKey) this.pressed.add('meta');
    }

    buildComboFromPressed(e) {
        const modifierOrder = ['ctrl', 'alt', 'shift', 'meta'];

        const keys = new Set(this.pressed);

        // đảm bảo modifier đúng
        if (e.ctrlKey) keys.add('ctrl');
        if (e.altKey) keys.add('alt');
        if (e.shiftKey) keys.add('shift');
        if (e.metaKey) keys.add('meta');

        const modifiers = [];
        let mainKey = [];

        keys.forEach(k => {
            if (modifierOrder.includes(k)) {
                modifiers.push(k);
            } else {
                mainKey.push(k);
            }
        });

        modifiers.sort(
            (a, b) => modifierOrder.indexOf(a) - modifierOrder.indexOf(b)
        );

        if (!mainKey) return null;

        return [...modifiers, ...mainKey.sort()].join('+');
    }

    normalizeKey(key) {
        if (!key) return null;

        const k = key.toLowerCase();

        const map = {
            control: 'ctrl',
            alt: 'alt',
            shift: 'shift',
            meta: 'meta',
            arrowup: 'arrow_up',
            arrowdown: 'arrow_down',
            arrowleft: 'arrow_left',
            arrowright: 'arrow_right',
            escape: 'esc',
            ' ': 'space',
        };

        return map[k] || k;
    }
}

export const hotkeyManager = new HotkeyManager();